import { render, staticRenderFns } from "./ListBody.vue?vue&type=template&id=eb5595a2&"
import script from "./ListBody.vue?vue&type=script&lang=js&"
export * from "./ListBody.vue?vue&type=script&lang=js&"
import style0 from "./ListBody.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListBody.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
})
